import { useLanguageHandler } from '@/hooks/useLanguageHandler';
import { createFileRoute } from '@tanstack/react-router';
import ErrorPage from '@/pages/404/ErrorPage';
import { useLingui } from '@lingui/react/macro';

const LegacyInvitationRedirectOrNotFound = () => {
	const { t } = useLingui();
	useLanguageHandler();
	const pathname = decodeURIComponent(window.location.pathname);
	const match = pathname.match(/^\/(accept-invitation(?:-token)?)\?(.+)$/);
	if (match) {
		// Legacy invitation emails had query params encoded in the pathname
		// Use window.location for this redirect since the URL is malformed
		window.location.replace(`/${match[1]}?${match[2]}`);
		return null;
	}
	return <ErrorPage title={t`Page Doesn't Exist`} />;
};

export const Route = createFileRoute('/$')({
	component: LegacyInvitationRedirectOrNotFound,
});
